import {
  WebsiteSettingsInterface,
  WebsiteSettingsState,
  WebsiteStylesInterface,
  WebsiteThemeInterface,
  WebsiteThemeListInterface,
} from './website-settings-types'
import {
  SET_WEBSITE_SETTINGS,
  SET_WEBSITE_STYLES,
  SET_WEBSITE_THEME,
  SET_WEBSITE_THEMES_LIST,
} from './website-settings-action-type'
import { AnyAction } from 'redux'

const defaultReducerState: WebsiteSettingsState = {
  websiteStyles: null,
  websiteThemesList: [],
  websiteTheme: null,
  websiteId: null,
  websiteLayoutPageId: null,
  websiteLocales: [],
}

export interface WebsiteStylesAction {
  type: typeof SET_WEBSITE_STYLES
  payload: WebsiteStylesInterface
}

export interface WebsiteThemeAction {
  type: typeof SET_WEBSITE_THEME
  payload: WebsiteThemeInterface
}

export interface WebsiteThemeListAction {
  type: typeof SET_WEBSITE_THEMES_LIST
  payload: WebsiteThemeListInterface[]
}

export interface WebsiteSettingsAction {
  type: typeof SET_WEBSITE_SETTINGS
  payload: WebsiteSettingsInterface
}

export type WebsiteSettingsActionType =
  | WebsiteStylesAction
  | WebsiteThemeAction
  | WebsiteThemeListAction
  | WebsiteSettingsAction

export const websiteSettingsReducer = (
  // biome-ignore lint/style/useDefaultParameterLast: <explanation>
  state: WebsiteSettingsState = defaultReducerState,
  action: WebsiteSettingsActionType | AnyAction,
): WebsiteSettingsState => {
  switch (action.type) {
    case SET_WEBSITE_STYLES:
      return {
        ...state,
        websiteStyles: action.payload,
      }
    case SET_WEBSITE_THEMES_LIST:
      return {
        ...state,
        websiteThemesList: action.payload,
      }
    case SET_WEBSITE_THEME:
      return {
        ...state,
        websiteTheme: action.payload,
      }
    case SET_WEBSITE_SETTINGS:
      return {
        ...state,
        websiteId: action.payload.id,
        websiteLayoutPageId: action.payload.layoutPageId,
        websiteLocales: action.payload.locales,
        websiteStyles: action.payload.style,
        websiteTheme: action.payload.theme,
      }
    default:
      return state
  }
}
